<template>
  <div class="transaction-categories">
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Danh sách danh mục thu chi'">
          <template v-slot:toolbar>
            <div class="row">
              <b-button
                v-show="checkPermission('TRANSACTION_CATE_INSERT')"
                variant="primary"
                size="sm"
                @click="showModalAddCate()"
                class="btn btn-primary font-weight-bolder btn-sm"
                :aria-label="'Tạo mới danh mục'"
              >
                <i
                  style="font-size: 1rem"
                  class="flaticon2-add-1"
                  aria-hidden="true"
                ></i>
                Tạo mới
              </b-button>
            </div>
          </template>
          <template v-slot:preview>
            <SearchForm
              @search="onSearch"
              :initial-values="{ name: searchName, code: searchCode }"
            />

            <AddCategoryModal
              ref="add-cate-modal"
              :form-data="formData"
              :list-cate="listCate"
              @submit="createCategory"
            />
            <UpdateCategoryModal
              ref="update-cate-modal"
              :form-data="formData"
              :list-cate="listCate"
              @submit="updateCategory"
            />

            <!-- <LoadingSpinner
              v-if="onLoading"
              overlay
              message="Đang tải..."
            /> -->

            <!-- <CategoryTable
              v-else
              :items="listItem"
              :loading="onLoading"
              :total="totalRow"
              :check-view-only="checkViewOnly()"
              @edit="editItem"
              @add-child="addChildCate"
              @delete="showDeleteAlert"
            /> -->
            <CategoryTable
              :items="listItem"
              :loading="onLoading"
              :total="totalRow"
              :check-view-only="checkViewOnly()"
              @edit="editItem"
              @add-child="addChildCate"
              @delete="showDeleteAlert"
            />
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import localData from '@/utils/saveDataToLocal';
import { getToastInstance } from '@/utils/toastHelper';
import Swal from 'sweetalert2';
import { mapActions, mapState } from 'vuex';

const KTCodePreview = () =>
  import(
    /* webpackChunkName: "KTCodePreview" */ '@/view/content/CodePreview.vue'
  );
const CategoryTable = () =>
  import(
    /* webpackChunkName: "CategoryTable" */ './components/CategoryTable.vue'
  );
const SearchForm = () =>
  import(/* webpackChunkName: "SearchForm" */ './components/SearchForm.vue');
const AddCategoryModal = () =>
  import(
    /* webpackChunkName: "AddCategoryModal" */ './components/AddCategoryModal.vue'
  );
const UpdateCategoryModal = () =>
  import(
    /* webpackChunkName: "UpdateCategoryModal" */ './components/UpdateCategoryModal.vue'
  );

// const LoadingSpinner = () =>
//   import(
//     /* webpackChunkName: "LoadingSpinner" */ '@/components/common/LoadingSpinner.vue'
//   );

export default {
  name: 'TransactionCategoryList',
  components: {
    KTCodePreview,
    SearchForm,
    CategoryTable,
    AddCategoryModal,
    UpdateCategoryModal,
    // LoadingSpinner,
  },
  mixins: [getToastInstance()],
  data() {
    return {
      formData: {
        name: '',
        code: '',
        parentId: null,
        type: null,
        contactId: null,
      },
      cateId: 0,
      searchName: '',
      searchCode: '',
    };
  },
  computed: {
    ...mapState('transactionCategory', [
      'categories',
      'parentCategories',
      'loading',
      'totalRows',
    ]),
    listItem() {
      return this.categories.map((element, index) => ({
        id: element.id,
        stt: index + 1,
        name: element.name,
        code: element.code,
        level: element.level,
        type: element.type,
        status: element.status,
        typeName: element.typeName,
      }));
    },
    listCate() {
      return this.parentCategories.map((element) => ({
        id: element.id,
        name: this.formatCategoryName(element.name, element.level),
      }));
    },
    onLoading() {
      return this.loading;
    },
    totalRow() {
      return this.totalRows;
    },
  },
  created() {
    this.initializeData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Danh mục thu chi', route: '/transaction-categories' },
      { title: 'Danh sách danh mục thu chi' },
    ]);
  },
  methods: {
    ...mapActions('transactionCategory', [
      'fetchCategories',
      'fetchParentCategories',
      'deleteCategory',
    ]),
    ...mapActions('transactionCategory', {
      getCategoryByIdAction: 'getCategoryById',
      updateCategoryAction: 'updateCategory',
      createCategoryAction: 'createCategory',
    }),
    checkPermission(permission) {
      return localData.checkPermission(permission);
    },
    checkViewOnly() {
      const permissions = ['TRANSACTION_CATE_VIEW', 'TRANSACTION_CATE_UPDATE'];
      return (
        permissions.filter((permission) => this.checkPermission(permission))
          .length === 1
      );
    },
    async initializeData() {
      await Promise.all([
        this.fetchCategories({ name: this.searchName, code: this.searchCode }),
        this.fetchParentCategories(),
      ]);
    },
    formatCategoryName(name, level) {
      const prefix = '- '.repeat(level);
      return level > 0 ? `${prefix}${name}` : name;
    },
    formatAccountName(name, level) {
      const prefix = '- '.repeat(level);
      return `${prefix}${name}`;
    },
    async deleteItem(item) {
      const result = await this.deleteCategory(item.id);
      if (result.success) {
        makeToastSuccess(result.message);
        await this.initializeData();
      } else {
        makeToastFaile(result.message);
      }
    },
    async updateCategory(formData) {
      const result = await this.updateCategoryAction(formData);
      if (result.success) {
        makeToastSuccess(result.message);
        this.$refs['update-cate-modal'].hideModal();
      } else {
        makeToastFaile(result.message);
      }
    },
    async createCategory(formData) {
      const result = await this.createCategoryAction(formData);
      if (result.success) {
        makeToastSuccess(result.message);
        this.$refs['add-cate-modal'].hideModal();
      } else {
        makeToastFaile(result.message);
      }
    },
    async editItem(item) {
      this.cateId = item.id;
      const result = await this.getCategoryByIdAction(item.id);
      if (result.success) {
        this.formData = { ...result.data };
        this.$nextTick(() => {
          this.showModalUpdateCate();
        });
      } else {
        makeToastFaile(result.message);
      }
    },
    addChildCate(item) {
      this.showModalAddCate({
        name: '',
        code: '',
        parentId: item.id,
        type: null,
        contactId: null,
      });
    },
    showModalAddCate(
      updateFormData = {
        name: '',
        code: '',
        parentId: null,
        type: null,
        contactId: null,
      },
    ) {
      this.formData = updateFormData;
      this.$nextTick(() => {
        this.$refs['add-cate-modal'].showModal();
      });
    },
    hideModalAddCate() {
      this.$refs['add-cate-modal'].hideModal();
      this.formData = {
        name: '',
        code: '',
        parentId: null,
        type: null,
        contactId: null,
      };
    },
    showModalUpdateCate() {
      this.$refs['update-cate-modal'].showModal();
    },
    hideModalUpdateCate() {
      this.$refs['update-cate-modal'].hideModal();
      this.formData = {
        name: '',
        code: '',
        parentId: null,
        type: null,
        contactId: null,
      };
    },
    onSearch(searchParams) {
      this.searchName = searchParams.name;
      this.searchCode = searchParams.code;
      this.fetchCategories({ name: this.searchName, code: this.searchCode });
    },
    showDeleteAlert(item) {
      Swal.fire({
        title: 'Xóa danh mục!',
        text: 'Bạn có chắc muốn xóa danh mục này không?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.deleteItem(item);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction-categories {
  .icon {
    padding-top: 7px;
    &:hover {
      background-color: #90c6fc;
    }
  }

  .container-fluid {
    height: 100%;
    display: table;
    width: 100%;
    padding: 0;
  }

  .row-fluid {
    height: 100%;
    display: table-cell;
    vertical-align: middle;
  }

  .centering {
    float: none;
    margin: 0 auto;
  }
}
</style>
